import type { AutomationOfferCheckWire, CampaignOfferWire, EditionStatsWire, OfferUsageWire, OfferWire } from './contracts';
import type { AutomationOfferCheck, CampaignOffer, EditionStats, FunnelOffer, OfferUsage } from './types';

export function decodeOffer(wire: OfferWire): FunnelOffer {
  return {
    id: wire.id,
    title: wire.title,
    description: wire.description,
    status: wire.status,
    coverImageUrl: wire.cover_image_url,
    fileSize: wire.file_size,
    edition: wire.edition,
    replacesOfferId: wire.replaces_offer_id,
    createdAt: wire.created_at,
  };
}

export function decodeUsage(wire: OfferUsageWire): OfferUsage {
  return {
    usageType: wire.usage_type,
    refId: wire.ref_id,
    refName: wire.ref_name,
    refStatus: wire.ref_status,
    deliveredOfferId: wire.delivered_offer_id,
    deliveredOfferTitle: wire.delivered_offer_title,
  };
}

export function decodeEditionStats(wire: EditionStatsWire): EditionStats {
  return {
    offerId: wire.offer_id,
    edition: wire.edition,
    title: wire.title,
    downloads: wire.downloads,
    enrolledLeads: wire.enrolled_leads,
  };
}

export function decodeCampaignOffer(wire: CampaignOfferWire): CampaignOffer {
  return {
    id: wire.id,
    name: wire.name,
    offerId: wire.offer_id,
    offer: wire.offer ? decodeOffer(wire.offer) : null,
    canChangeOffer: wire.capabilities.can_change_offer,
    automations: wire.automations,
    enrollmentsByOffer: wire.enrollments_by_offer.map((row) => ({
      offerId: row.offer_id,
      title: row.title,
      count: row.count,
    })),
  };
}

export function decodeAutomationOfferCheck(wire: AutomationOfferCheckWire): AutomationOfferCheck {
  return {
    id: wire.id,
    name: wire.name,
    status: wire.status,
    trigger: {
      campaignId: wire.trigger.campaign_id,
      campaignName: wire.trigger.campaign_name,
      campaignStatus: wire.trigger.campaign_status,
      campaignOffer: wire.trigger.campaign_offer ? decodeOffer(wire.trigger.campaign_offer) : null,
    },
    emails: wire.emails.map((email) => ({
      id: email.id,
      subject: email.subject,
      status: email.status,
      offerSource: email.offer_source,
      pinnedOfferId: email.pinned_offer_id,
      pinnedOffer: email.pinned_offer ? decodeOffer(email.pinned_offer) : null,
    })),
  };
}
